import cx from 'classnames';

import { MDText } from 'i18n-react';

import { LANDING_PAGE_EVENTS, LANDING_PAGE_SECTIONS_NAMES } from 'Utilities/analytics';
import {
  HOMEPAGE_GA_TAGS,
  HOMEPAGE_SECTIONS,
} from 'Utilities/analytics/analyticsHomePage';

import aa from '../../../../../../client/assets_seller/partners/aa.svg';
import confused from '../../../../../../client/assets_seller/partners/confused.svg';
import goCompare from '../../../../../../client/assets_seller/partners/goCompare.svg';
import moneySuperMarket from '../../../../../../client/assets_seller/partners/moneySuperMarket.svg';
import octopus from '../../../../../../client/assets_seller/partners/octopusNew.svg';
import { PartnerLogos } from '../../../../../components/partnerLogos/PartnerLogos';
import type { AcfLogos } from '../../@types/landingPages';

import { toLogoList, toLogoSrc } from './RecommendedBy.helpers';
import LocalTexts from './RecommendedByTexts.json';

import styles from './RecommendedBy.scss';

const LocalT = new MDText(LocalTexts);

const t = (key: string) => LocalT.translate(key) as string;

const TEXT = {
  aa: t('partner.altTexts.aa'),
  confused: t('partner.altTexts.confused'),
  goCompare: t('partner.altTexts.goCompare'),
  moneySuperMarket: t('partner.altTexts.moneySuperMarket'),
  octopus: t('partner.altTexts.octopus'),
  title: t('partner.title'),
};

const STANDARD_LOGOS = [
  { alt: TEXT.aa, height: 40, id: 1, src: aa, width: 37.5 },
  { alt: TEXT.confused, height: 40, id: 2, src: confused, width: 145 },
  { alt: TEXT.octopus, height: 40, id: 3, src: octopus, width: 142.5 },
  {
    alt: TEXT.moneySuperMarket,
    height: 40,
    id: 4,
    src: moneySuperMarket,
    width: 107.5,
  },
  {
    alt: TEXT.goCompare,
    height: 40,
    id: 5,
    src: goCompare,
    width: 153.75,
  },
];

type Page = 'homepage' | 'landingPage';

const SECTION_LOAD_BY_PAGE: Record<Page, () => void> = {
  homepage: () => HOMEPAGE_GA_TAGS.SECTION_LOADED(HOMEPAGE_SECTIONS.RECOMMENDED_BY),
  landingPage: () => LANDING_PAGE_EVENTS.SECTION_LOAD({
    name: LANDING_PAGE_SECTIONS_NAMES.RECOMMENDED_BY,
  }),
};

type RecommendedByProps = {
  className?: string;
  logos?: AcfLogos;
  page?: Page;
}

export const RecommendedBy = ({ className, logos, page = 'landingPage' }: RecommendedByProps) => {
  const customLogos = toLogoList(logos);
  const onRefTrigger = SECTION_LOAD_BY_PAGE[page];

  return (
    <PartnerLogos {...{ className, onRefTrigger }}>
      {customLogos.length ? (
        <div className={styles.customLogos} data-testid="customPartnerLogos">
          {customLogos.map(({ alt, height, id, url, width }, index) => (
            <img
              key={id ?? `${url}-${index}`}
              alt={alt ?? ''}
              className={styles.customLogo}
              loading="lazy"
              src={toLogoSrc(url)}
              {...{ height, width }}
            />
          ))}
        </div>
      ) : STANDARD_LOGOS.map(({ alt, height, id, src, width }) => (
        <span key={id} className={cx(styles.logo, styles[`logo${id}`])}>
          <img
            loading="lazy"
            {...{ alt, height, src, width }}
          />
        </span>
      ))}
    </PartnerLogos>
  );
};
